import React, { useState } from "react";
import {
  Box,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Chip,
  Tooltip,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import HistoryIcon from "@mui/icons-material/History";
import LinkIcon from "@mui/icons-material/Link";
import FormularioOT from "./FormularioOT";
import ServicioAvatar from "../../../components/ServicioAvatar";
import EmparejarDialog from "./EmparejarDialog";
import EquiposChips from "../../requerimiento/components/EquiposChips";

const TablaClientesOT = ({
  clientes = [],
  equiposMap = {},
  page = 0,
  rowsPerPage = 30,
  total = 0,
  onPageChange,
  onRowsPerPageChange,
  onOpenHistorial,
}) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  const [openEmparejar, setOpenEmparejar] = useState(false);
  const [clienteEmparejar, setClienteEmparejar] = useState(null);

  const handleOpenDialog = (cliente) => {
    setClienteSeleccionado(cliente);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setClienteSeleccionado(null);
  };

  const handleOpenEmparejar = (cliente) => {
    setClienteEmparejar(cliente);
    setOpenEmparejar(true);
  };

  const handleCloseEmparejar = () => {
    setOpenEmparejar(false);
    setClienteEmparejar(null);
  };

  if (!clientes.length) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ fontStyle: "italic", py: 2 }}>
        No se encontraron clientes.
      </Typography>
    );
  }

  return (
    <>
      <TableContainer component={Paper}>
        <Table
          size="small"
          sx={{
            "& .MuiTableCell-root": { px: 0.75, py: 0.35, fontSize: "0.75rem", lineHeight: 1.25, verticalAlign: "top" },
            "& .MuiTableCell-head": { fontWeight: 700, whiteSpace: "nowrap", py: 0.5 },
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: 76 }}>Cod Cliente</TableCell>
              <TableCell sx={{ width: 76 }}>Cod</TableCell>
              <TableCell sx={{ width: 290 }}>Cliente</TableCell>
              <TableCell sx={{ width: 130 }}>Grupo</TableCell>
              <TableCell sx={{ width: 150 }}>Nombre</TableCell>
              <TableCell sx={{ width: 80 }}>Servicio</TableCell>
              <TableCell sx={{ width: 100 }}>Sucursal</TableCell>
              <TableCell sx={{ width: 170 }}>Equipos</TableCell>
              <TableCell sx={{ width: 90 }}>Estado</TableCell>
              <TableCell sx={{ width: 150 }}>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {clientes.map((cli) => (
              <TableRow key={cli.cod_servicio_cliente} hover>
                <TableCell>{cli.cod_cliente}</TableCell>
                <TableCell>{cli.cod_servicio_cliente}</TableCell>
                <TableCell>
                  <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0.75 }}>
                    <ServicioAvatar imagen={cli.imagen_principal} nombre={cli.nombre_cliente} />
                    <Box sx={{ minWidth: 0 }}>
                      <Box component="span" sx={{ display: "block", fontWeight: 600, overflowWrap: "anywhere" }}>{cli.nombre_cliente}</Box>
                      {cli.descripcion && (
                        <Typography variant="caption" color="text.secondary" sx={{ display: "block", fontSize: "0.72rem", lineHeight: 1.25, overflowWrap: "anywhere" }}>
                          {cli.descripcion}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </TableCell>
                <TableCell sx={{ overflowWrap: "anywhere" }}>{cli.grupo || "-"}</TableCell>
                <TableCell sx={{ overflowWrap: "anywhere" }}>{cli.nombre || "-"}</TableCell>
                <TableCell>{cli.nombre_servicio}</TableCell>
                <TableCell>{cli.sucursal_facturar}</TableCell>
                <TableCell>
                  <EquiposChips equiposMap={equiposMap} codServicioCliente={cli.cod_servicio_cliente} />
                </TableCell>
                <TableCell>
                  <Chip
                    size="small"
                    label={cli.estado || "-"}
                    color={cli.estado === "Activo" ? "success" : "default"}
                    sx={{ height: 18, fontSize: "0.68rem" }}
                  />
                </TableCell>
                <TableCell>
                  <Box sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
                    <Tooltip title="Emitir Orden de Trabajo">
                      <IconButton
                        size="small"
                        sx={{ color: "success.main" }}
                        onClick={() => handleOpenDialog(cli)}
                      >
                        <AddIcon fontSize="inherit" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Emparejar equipos">
                      <IconButton
                        size="small"
                        sx={{ color: "primary.main" }}
                        onClick={() => handleOpenEmparejar(cli)}
                      >
                        <LinkIcon fontSize="inherit" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Historial">
                      <IconButton
                        size="small"
                        sx={{ color: "gray" }}
                        onClick={() => onOpenHistorial?.(cli)}
                      >
                        <HistoryIcon fontSize="inherit" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={total}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[10, 30, 50, 100]}
        labelRowsPerPage="Filas por pagina"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `mas de ${to}`}`
        }
        onPageChange={(_, nextPage) => onPageChange?.(nextPage)}
        onRowsPerPageChange={(e) => onRowsPerPageChange?.(Number(e.target.value))}
        sx={{ minHeight: 40, "& .MuiTablePagination-toolbar": { minHeight: 40, px: 1 } }}
      />

      {clienteSeleccionado && (
        <FormularioOT open={openDialog} onClose={handleCloseDialog} cliente={clienteSeleccionado} />
      )}

      {clienteEmparejar && (
        <EmparejarDialog open={openEmparejar} onClose={handleCloseEmparejar} cliente={clienteEmparejar} />
      )}
    </>
  );
};

export default TablaClientesOT;
